module.exports = __webpack_public_path__ + "static/media/PA-Icon-Wasserhahn-pos.3414fa40.svg";